import React from 'react'
import MarkdownIt from 'markdown-it'
import MdEditor from 'react-markdown-editor-lite'
import MarkdownItKatex from '@iktakahiro/markdown-it-katex'
import katex from 'katex'
import 'react-markdown-editor-lite/lib/index.css'
import Cookies from 'js-cookie'
import InsertImgPlugin from './plugin/InsertImagPlugin'

export const mdParser = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
})
mdParser.use(MarkdownItKatex, { katex })

export interface EditorProps {
  onBlur?: any
  placeholder?: any
  height?: number
  toolbar?: any
  preview?: boolean
  onChange?: any
  value?: any
  uploadOption?: any
  specialOptons?: any
  autoFocus?: boolean
  renderViewContent?: any
}

export const MarkDownEditor: React.FC<EditorProps> = (props) => {
  const {
    onChange,
    preview,
    toolbar,
    onBlur,
    placeholder,
    height,
    value,
    uploadOption,
    specialOptons,
    autoFocus,
    renderViewContent,
  } = props
  MdEditor.use(InsertImgPlugin, {
    name: uploadOption?.name,
    actionUrl: uploadOption?.actionUrl,
    uploadData: uploadOption?.uploadData,
    uploadImageList: uploadOption?.uploadImageList,
    setUploadImageList: uploadOption?.setUploadImageList,
  })

  const plugins: any = ['emoji', 'img-upload', 'control-enter']

  const notePlugins: any = [
    'header',
    'fonts-bold',
    'emoji',
    'fonts-italic',
    'fonts-underline',
    'fonts-strikethrough',
    'list-unordered',
    'list-ordered',
    'block-quote',
    'block-wrap',
    'block-code-inline',
    'block-code-block',
    'table',
    // 'image',
    //'img-upload',
    'link',
    'clear',
    'mode-toggle',
    'full-screen',
    'tab-insert',
  ]

  const allPlugins: any = [
    'header',
    'fonts-bold',
    'emoji',
    'fonts-italic',
    'fonts-underline',
    'fonts-strikethrough',
    'list-unordered',
    'list-ordered',
    'block-quote',
    'block-wrap',
    'block-code-inline',
    'block-code-block',
    'table',
    // 'image',
    'img-upload',
    'link',
    'clear',
    'mode-toggle',
    'full-screen',
    'tab-insert',
  ]
  const mdConfig = {
    view: {
      menu: true,
      md: true,
      html: preview ? true : false,
      fullScreen: true,
      hideMenu: true,
    },
    table: {
      maxRow: 10,
      maxCol: 10,
    },
    syncScrollMode: ['leftFollowRight', 'rightFollowLeft'],
  }
  // const handleEditorChange = ({ html, text }) => {
  //   // console.log('handleEditorChange', html, text)
  //   console.log('handleEditorChange', text)
  // }

  // const handleImageUpload = (file) => {
  //   console.log("file======",file);

  //   return new Promise((resolve) => {
  //     const reader = new FileReader()
  //     reader.onload = (data) => {
  //       resolve(data.target?.result)
  //     }
  //     reader.readAsDataURL(file)
  //   })
  // }

  // const handleKeyCommand = (command, editor) => {
  //   if (command === 'shift-enter') {
  //     editor.insertText('\n')
  //     return true
  //   }
  //   return false
  // }

  const renderHTML = (text) => {
    // console.log('mdParser', text)
    if (renderViewContent) {
      return renderViewContent
    } else {
      return mdParser.render(text)
    }
  }

  return (
    <MdEditor
      plugins={
        toolbar == 'all' ? allPlugins : toolbar == 'chat' ? plugins : toolbar == 'note' ? notePlugins : toolbar
      }
      style={{ height: height ? height + 'px' : '200px' }}
      config={mdConfig}
      renderHTML={renderHTML}
      onChange={onChange}
      onFocus={(e) => console.log('focus', e)}
      onBlur={onBlur}
      placeholder={placeholder}
      value={value}
      autoFocus={autoFocus}
      id="md-editor-id"
    />
  )
}

export default MarkDownEditor
